import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addFarmDataSubmission } from "services";

import { invalidateFieldPracticesByFarmId } from "utils";

import { ADD_FARM_DATA_SUBMISSION, GET_FARM_DATA_SUBMISSION_STATUS, GET_FARM_REPORTING_YEAR } from "consts";

export const useAddFarmSubmission = ({ farmId }: { farmId: string }) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [ADD_FARM_DATA_SUBMISSION, farmId],
    mutationFn: addFarmDataSubmission,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_FARM_DATA_SUBMISSION_STATUS, farmId] });
      queryClient.invalidateQueries({ queryKey: [GET_FARM_REPORTING_YEAR, farmId] });
      // submitting locks the reporting year's practices, so refetch them for their new confirmation status
      invalidateFieldPracticesByFarmId(farmId);
    },
  });
};
